// N-089/N-090: единый формат денег (всегда 2 знака после запятой — копейки, важно для
// бухучёта, чтобы во всех местах приложения цифры совпадали) и русская плюрализация.

export function fmtMoney(n) {
  return (Number(n) || 0).toLocaleString('ru', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtCount(n) {
  return Math.round(Number(n) || 0).toLocaleString('ru');
}

// plural(3, ['заявка', 'заявки', 'заявок']) -> 'заявки'
export function plural(n, forms) {
  const n100 = Math.abs(Math.round(n)) % 100;
  const n10 = n100 % 10;
  if (n100 >= 11 && n100 <= 14) return forms[2];
  if (n10 === 1) return forms[0];
  if (n10 >= 2 && n10 <= 4) return forms[1];
  return forms[2];
}
